<template>
  <div class="candidato-wrapper">
    <router-link
      :to="{ name: 'candidato_conselho', params: { candidato } }"
      class="foto-wrapper"
    >
      <img
        :src="candidato.url_foto"
        alt="Foto do candidato"
        class="foto-candidato"
      />
    </router-link>
    <div class="dados-candidato">
      <p>
        {{ candidato.posicao }}º - {{ candidato.nome }} -
        {{ candidato.numero }}
      </p>
      <div class="progress">
        <div
          class="progress-bar progress-bar-success"
          role="progressbar"
          :aria-valuenow="perc * 10"
          aria-valuemin="0"
          aria-valuemax="100"
          :style="{
            width: perc * 10 + '%'
          }"
        >
          <span>
            Votos: {{ candidato.total_votos.toLocaleString() }} ( {{ perc }}% )
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    candidato: { type: Object, required: true },
    perc: { type: String, required: true }
  }
}
</script>

<style scoped>
.candidato-wrapper {
  padding: 15px 15px;
  display: flex;
  align-items: center;
  gap: 30px;
}

.progress {
  background-color: gray;
  height: 40px;
}

.foto-candidato {
  height: 90px;
  border-radius: 50%;
  display: flex;
  align-items: center;
}

.foto-wrapper {
  border: 1px solid #dcdcdc;
  border-radius: 50%;
  min-height: 90px;
  display: flex;
  align-items: center;
  text-align: center;
  margin-bottom: 15px;
  align-self: flex-end;
}

.dados-candidato {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: flex-end;
}

.dados-candidato p {
  font-weight: 600;
  font-size: 1.3em;
}

.progress-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2em;
  position: relative;
}

.progress-bar > span {
  position: absolute;
  width: 300px;
  left: -45px;
}

@media (min-width: 768px) {
  .progress-bar > span {
    left: -15px;
  }
  .dados-candidato p {
    font-size: 1.8em;
  }

  .foto-candidato {
    height: 150px;
  }

  .foto-wrapper {
    margin-bottom: 0px;
    min-height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EleicaoConselho/ProgressoCandidato.vue